import api from './api.js'

// Hours Service
export const hoursService = {
  async getWeeklyAvailability(params = {}) {
    const response = await api.get('/hours/weekly-availability', { params })
    return response.data.success ? response.data : { success: true, data: [], period: {} }
  },

  async getHours(params = {}) {
    const response = await api.get('/hours', { params })
    return response.data.success ? response.data.data : []
  },

  async getEmployeeActivities(params = {}) {
    const response = await api.get('/hours/employee-activities', { params })
    return response.data.success ? response.data : { success: true, data: [], period: {} }
  },

  async getStats() {
    const response = await api.get('/hours/stats')
    return response.data.success ? response.data.data : {}
  },

  async getRevenuePerTeam() {
    const response = await api.get('/hours/revenue/per-team')
    return response.data.success ? response.data.data : null
  },

  async getCapacityMetrics() {
    const response = await api.get('/hours/capacity-metrics')
    return response.data.success ? response.data.data : null
  },

  async getCapacityMetricsPerTeam() {
    const response = await api.get('/hours/capacity-metrics/per-team')
    return response.data.success ? response.data.data : null
  },

  async getCapacityMetricsPerFunction() {
    const response = await api.get('/hours/capacity-metrics/per-function')
    return response.data.success ? response.data.data : null
  },

  async getCapacityMetricsPerTeamAndFunction() {
    const response = await api.get('/hours/capacity-metrics/per-team-and-function')
    return response.data.success ? response.data.data : null
  },

  async sync() {
    const response = await api.post(
      '/hours/sync',
      {},
      {
        timeout: 600000 // 10 minutes for hours sync (can take long due to large dataset)
      }
    )
    return response.data
  },

  async deleteAll() {
    const response = await api.delete('/hours/all')
    return response.data
  }
}
